import * as RadixRadioGroup from '@radix-ui/react-radio-group';

import { cardSurface } from '@/components/atoms/Card';

import styles from './PenPicker.module.scss';

export interface PenPickerOption {
    cageId: number;
    label: string;
    /** "Empty", "Current pen" or the group holding it. */
    detail: string;
    /** Only empty pens can be picked; the others are shown for orientation. */
    disabled: boolean;
}

interface PenPickerProps {
    options: PenPickerOption[];
    value: number | null;
    onChange: (cageId: number) => void;
    /** Names the group of pens for assistive technology. */
    'aria-label': string;
    'aria-describedby'?: string;
}

/**
 * The site's pens as tiles, one of which is picked: a radio group, so arrow keys move between
 * the pens that can be picked and Tab leaves it.
 */
export default function PenPicker(props: PenPickerProps) {
    const { options, value, onChange } = props;
    return (
        <RadixRadioGroup.Root
            className={styles.grid}
            value={value === null ? '' : String(value)}
            onValueChange={(next) => onChange(Number(next))}
            aria-label={props['aria-label']}
            aria-describedby={props['aria-describedby']}>
            {options.map((option) => (
                <RadixRadioGroup.Item
                    key={option.cageId}
                    value={String(option.cageId)}
                    disabled={option.disabled}
                    {...cardSurface(
                        {
                            variant: 'outlined',
                            radius: 'sm',
                            padding: 'xs',
                            interactive: true,
                            selected: value === option.cageId,
                        },
                        styles.tile
                    )}>
                    <span className={styles.label}>{option.label}</span>
                    <span className={styles.detail}>{option.detail}</span>
                </RadixRadioGroup.Item>
            ))}
        </RadixRadioGroup.Root>
    );
}
